import { Injectable } from '@angular/core';
import { SHARED_PATIENT_ASSISTANCE_OCC_LIST } from '@libs/shared/domain/patient-assistance/occ/shared-patient-assistance-occ.type';
import { SourceFilterOptionsLoader, toOptions } from '@shared/dataview/options/filter-options.registry';
import { SelectListItem } from '@shared/models/select-list-item';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OccOptionsLoader extends SourceFilterOptionsLoader {
  readonly source = 'occ';

  load(): Observable<SelectListItem[]> {
    return of(toOptions([...SHARED_PATIENT_ASSISTANCE_OCC_LIST]));
  }
}
